// extracted by mini-css-extract-plugin
module.exports = {"main":"styles_main__1pQrh","menuItem":"styles_menuItem__1lljw","active":"styles_active__1TpXa","white":"styles_white__1YaEr"};